import { RootState } from 'types'

export const setCurrentArticleId = (id: RootState['currentArticleId']) => ({
  type: 'SET_CURRENT_ARTICLE_ID',
  payload: id,
})
